import styled from 'styled-components';

export const OrderBumpContainer = styled.div<{ isChecked: boolean }>`
  background: ${props => props.isChecked ? '#147a5e' : '#fffbea'};
  border: 2px dashed ${props => props.isChecked ? '#0f5c48' : '#d4a900'};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin: 24px 0;
  transition: all 0.3s ease;
`;

export const OrderBumpHeader = styled.div<{ isChecked: boolean }>`
  background: ${props => props.isChecked ? '#0f5c48' : '#f7d548'};
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  gap: 5px;
`;

export const OrderBumpTitle = styled.h3<{ isChecked: boolean }>`
  font-size: 16px;
  font-weight: bold;
  color: ${props => props.isChecked ? '#fff' : '#8b6914'};
  margin: 0;
  flex: 1;
  transition: all 0.3s ease;

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

export const CheckmarkIcon = styled.div<{ isChecked: boolean }>`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  background: ${props => props.isChecked ? '#fff' : 'transparent'};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  svg {
    width: ${props => props.isChecked ? '16px' : '20px'};
    height: ${props => props.isChecked ? '16px' : '20px'};
    color: ${props => props.isChecked ? '#147a5e' : '#8b6914'};
  }
`;

export const OrderBumpContent = styled.div<{ isChecked: boolean }>`
  padding: 16px;
  background: ${props => props.isChecked ? '#147a5e' : '#fffbea'};
  transition: all 0.3s ease;

  @media (max-width: 640px) {
    padding: 12px;
  }
`;

export const ProductInfo = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

export const BumpProductImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const ProductDetailsWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ProductDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
`;

export const ProductName = styled.p<{ isChecked: boolean }>`
  font-size: 14px;
  font-weight: bold;
  color: ${props => props.isChecked ? '#fff' : '#1f2937'};
  margin: 0;
  flex: 1;
  transition: all 0.3s ease;
`;

export const OriginalPrice = styled.span<{ isChecked: boolean }>`
  font-size: 12px;
  color: ${props => props.isChecked ? 'rgba(255, 255, 255, 0.7)' : '#6b7280'};
  text-decoration: line-through;
  transition: all 0.3s ease;
`;

export const DiscountBadge = styled.span`
  background: #fff;
  color: #147a5e;
  font-size: 11px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 12px;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ProductDescription = styled.p<{ isChecked: boolean }>`
  font-size: 13px;
  color: ${props => props.isChecked ? 'rgba(255, 255, 255, 0.9)' : '#4b5563'};
  margin: 0;
  line-height: 1.5;
  transition: all 0.3s ease;
`;

export const PriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
`;

export const FinalPrice = styled.span<{ isChecked: boolean }>`
  font-size: 18px;
  font-weight: bold;
  color: ${props => props.isChecked ? '#fff' : '#147a5e'};
  transition: all 0.3s ease;
`;

export const OrderBumpFooter = styled.div<{ isChecked: boolean }>`
  width: 100%;
  height: 44px;
  background: ${props => props.isChecked ? '#0f5c48' : '#f7d548'};
  display: flex;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s ease;

  span {
    font-size: 14px;
    color: ${props => props.isChecked ? '#fff' : '#8b6914'};
    font-weight: bold;
    transition: all 0.3s ease;
  }

  &:hover {
    background: ${props => props.isChecked ? '#0d4f3c' : '#f5cf2e'};
  }
`;
